import React from "react";
import styled from "styled-components";
import { IconType } from "react-icons";

const Button = styled.a<{ backgroundImage?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  border-radius: 12px;

  position: relative;
  padding: 1rem 1.5rem;
  color: #000;
  overflow: hidden;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  text-decoration: none;

  ${({ backgroundImage, theme }) =>
    backgroundImage
      ? `
        background-image: url(${backgroundImage});
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.3);
          z-index: 1;
          transition: background 0.3s ease;
        }
      `
      : `
        background-color: ${theme.primary};
      `}

  box-shadow: 0 4px 12px rgba(0,0,0,0.15);

  > * {
    position: relative;
    z-index: 2;
  }

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);

    ${({ backgroundImage, theme }) =>
      backgroundImage
        ? `&::before { background: rgba(0,0,0,0.1); }`
        : `background-color: ${theme.primaryDark};`}
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 4px;
  }

  @media (max-width: 768px) {
    height: 80px;
  }
`;

const IconContainer = styled.span`
  display: flex;
  align-items: center;
  font-size: 2.5rem;
  flex-shrink: 0;
  transition: color 0.3s ease;
  color: #fff;

  &:hover {
    color: ${({ theme }) => theme.accent};
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

interface LinkButtonProps {
  label: string;
  url: string;
  target?: string;
  rel?: string;
  urlIcon?: IconType;
  backgroundImage?: string;
}

export const LinkButton = ({
  label,
  url,
  target,
  rel,
  urlIcon,
  backgroundImage,
}: LinkButtonProps) => (
  <Button
    href={url}
    target={target}
    rel={rel}
    backgroundImage={backgroundImage}
  >
    {/* {urlIcon && <IconContainer>{React.createElement(urlIcon)}</IconContainer>} */}

    <IconContainer style={{ visibility: "hidden" }}>
      {urlIcon && React.createElement(urlIcon)}
    </IconContainer>
  </Button>
);
